import { render } from "./NavigationProcess.vue?vue&type=template&id=765fa148&scoped=true"
import script from "./NavigationProcess.vue?vue&type=script&lang=js"
export * from "./NavigationProcess.vue?vue&type=script&lang=js"

import "./NavigationProcess.vue?vue&type=style&index=0&id=765fa148&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765fa148"]])

export default __exports__